import { render, staticRenderFns } from "./ResetPassForce.vue?vue&type=template&id=5049a206&scoped=true"
import script from "./ResetPassForce.vue?vue&type=script&lang=js"
export * from "./ResetPassForce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5049a206",
  null
  
)

export default component.exports